import { useState } from 'react';
import { ProfileDisplayProps } from '../interface/interface';
import Toggle from './ToggleComponent';
import { Tooltip } from './Tooltip';

export const ProfileDisplay = (props: ProfileDisplayProps) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const getNotificationDisabledText = () => {
    if (props.isNotificationEnabled) {
      return 'Disabling this option will stop all notifications from being sent.';
    }
    return 'Enabling this option will activate notifications for the Patient.';
  };

  return (
    <div className="flex justify-between items-center flex-col lg:flex-row">
      <div className="flex items-center flex-col lg:flex-row justify-center lg:justify-start">
        <div className="w-20 h-20 bg-secondary-pink-400 rounded-full flex items-center justify-center">
          <p className="text-3xl text-primary-blue-500 font-bold">
            {props.intial}
          </p>
        </div>
        <p className="lg:ml-6 text-2xl xl:text-3xl text-primary-blue-500 font-bold">
          {props.name}
        </p>
      </div>
      <div className="flex items-center justify-between">
        <Toggle
          label="Notification Status"
          value={props.isNotificationEnabled}
          onToggle={(val) => props.toggleHandler(val)}
          readonly={false}
        />
        <div
          className="relative ml-3 cursor-pointer"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {showTooltip && (
            <Tooltip
              className="right-0 !w-[200px] !md:w-[520px] lg:!w-max break-words"
              text={getNotificationDisabledText()}
            />
          )}
          <i
            className="fa fa-question-circle-o text-primary-blue-500"
            aria-hidden="true"
          ></i>
        </div>
      </div>
    </div>
  );
};
